import { useReport } from './hooks/use-context';

export function InitialInfos() {
  const { body } = useReport();
  const { tipo_inspecao, participante, area, local, responsavel_area } = body;

  const cellStyle = {
    padding: '4px 8px',
    border: '1px solid black',
    textAlign: 'left' as const,
  };

  const valueStyle = {
    textAlign: 'center' as const,
    backgroundColor: '#ffffcc',
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
  };

  return (
    <div style={{ marginBottom: '8px' }}>
      <div
        style={{
          width: '100%',
          backgroundColor: '#d3d3d3',
          textAlign: 'center',
          padding: '4px',
          fontWeight: 'bold',
          border: '1px solid black',
          borderBottom: 'none',
        }}
      >
        INFORMAÇÕES
      </div>

      <div style={{ fontFamily: 'Arial, sans-serif' }}>
        <div style={gridStyle}>
          <div style={cellStyle}>TIPO DE INSPEÇÃO</div>
          <div style={{ ...cellStyle, ...valueStyle }}>
            {tipo_inspecao?.answers?.[0]?.option || tipo_inspecao?.answers?.[0]?.content || '-'}
          </div>
        </div>
        <div style={gridStyle}>
          <div style={{ ...cellStyle, borderTop: 'none' }}>PARTICIPANTE</div>
          <div style={{ ...cellStyle, ...valueStyle, borderTop: 'none' }}>
            {participante?.answers?.[0]?.option || participante?.answers?.[0]?.content || '-'}
          </div>
        </div>
        <div style={gridStyle}>
          <div style={{ ...cellStyle, borderTop: 'none' }}>ÁREA</div>
          <div style={{ ...cellStyle, ...valueStyle, borderTop: 'none' }}>
            {area?.answers?.[0]?.option || area?.answers?.[0]?.content || '-'}
          </div>
        </div>
        <div style={gridStyle}>
          <div style={{ ...cellStyle, borderTop: 'none' }}>LOCAL</div>
          <div style={{ ...cellStyle, ...valueStyle, borderTop: 'none' }}>
            {local?.answers?.[0]?.option || local?.answers?.[0]?.content || '-'}
          </div>
        </div>
        <div style={gridStyle}>
          <div style={{ ...cellStyle, borderTop: 'none' }}>
            RESPONSÁVEL DA ÁREA
          </div>
          <div style={{ ...cellStyle, ...valueStyle, borderTop: 'none' }}>
            {responsavel_area?.answers?.[0]?.option || responsavel_area?.answers?.[0]?.content || '-'}
          </div>
        </div>
      </div>
    </div>
  );
}
